import { combineReducers } from '@reduxjs/toolkit'
import { reducer as formReducer } from 'redux-form'
import features from './FeaturesSlice'
import { familyReducer } from 'APP/Store/Family'
import { contentReducer } from 'APP/Store/Content'
import { providerBookingReducer } from 'APP/Store/ProviderBooking'
import { videoSessionReducer } from 'APP/Store/VideoSession'
import { pharmaciesReducer } from 'APP/Store/Pharmacies'
import { nativeCallIOSReducer } from 'APP/Store/NativeCallIOS'
import { nativeCallAndroidReducer } from 'APP/Store/NativeCallAndroid'
import { placesReducer } from 'APP/Store/Places'
import { toastReducer } from 'APP/Store/Toast'
import { semanticSearchReducer } from 'APP/Store/SemanticSearch'
import { eligibilitySearchReducer } from 'APP/Store/EligibilitySearch'
import { zendeskReducer } from 'APP/Store/Zendesk'
import { initializationReducer } from 'APP/Store/Initialization'
import { preloadReducer } from 'APP/Store/Preload'
import { brownfieldReducer } from 'APP/Store/Brownfield'
import { memberTasksReducer } from 'APP/Store/MemberTasks'
import { reducer as appSessionReducer } from './AppSessionRedux'
import { reducer as deeplinkReducer } from './DeeplinkRedux'
import { reducer as wellnessCenterReducer } from './WellnessCenterRedux'
import { reducer as habitsReducer } from './HabitsRedux'
import { reducer as accountLinkingReducer } from './AccountLinkingRedux'
import { reducer as activeMinutesReducer } from './ActiveMinutesRedux'
import { reducer as wellBeingAssessmentReducer } from './WellBeingRedux'
import { reducer as appointmentBookingReducer } from './AppointmentBookingRedux'
import { reducer as appReducer } from './StartupRedux'
import { reducer as loginReducer } from './LoginRedux'
import { reducer as patientReducer } from './PatientRedux'
import { reducer as historyReducer } from './PatientHistoryRedux'
import { reducer as notificationsReducer } from './NotificationRedux'

const rootReducer = {
  // Non-persisted
  form: formReducer,
  initialization: initializationReducer,
  preload: preloadReducer,
  brownfield: brownfieldReducer,
  appSession: appSessionReducer,
  deeplink: deeplinkReducer,
  features,
  wellnessCenter: wellnessCenterReducer,
  habits: habitsReducer,
  accountLinking: accountLinkingReducer,
  activeMinutes: activeMinutesReducer,
  wellBeingAssessment: wellBeingAssessmentReducer,
  appointmentBooking: appointmentBookingReducer,
  nativeCallIOS: nativeCallIOSReducer,
  nativeCallAndroid: nativeCallAndroidReducer,
  places: placesReducer,
  toast: toastReducer,
  memberTasks: memberTasksReducer,
  // Persisted
  app: appReducer,
  login: loginReducer,
  patient: patientReducer,
  history: historyReducer,
  family: familyReducer,
  content: contentReducer,
  providerBooking: providerBookingReducer,
  notifications: notificationsReducer,
  videoSession: videoSessionReducer,
  pharmacies: pharmaciesReducer,
  semanticSearch: semanticSearchReducer,
  eligibilitySearch: eligibilitySearchReducer,
  zendesk: zendeskReducer,
}

export default combineReducers(rootReducer)
